import { produce } from 'immer';

const INITIAL_STATE = {
  profile: {},
};

export default function user(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@auth/SIGN_IN_SUCCESS':
      return produce(state, (draft) => {
        draft.profile = action.payload.user;
      });

    case '@user/UPDATE_SUCCESS':
      return produce(state, (draft) => {
        draft.profile = action.payload.user;
      });

    case '@user/AVATAR_UPDATE_SUCCESS':
      return produce(state, (draft) => {
        draft.profile.avatar = action.payload.avatar;
      });

    default:
      return state;
  }
}
